// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  overflow: hidden;
  height: 100%;
}

.main-table {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%; /* or whatever */
}

.table-inner-container {
  height: 200px;
  width: 550px;
  overflow: auto;
}

.table-container {
  height: 200px;
}

.table {
  margin-bottom: 0rem;
}

td.mat-mdc-cell {
  padding-top: 6px;
  width: auto;
  padding-left: 5px;
}

th.mat-mdc-header-cell {
  width: 10%;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.header-row {
  border-bottom: 1px solid #eee;
  margin-bottom: 5px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.table-header {
  border-top: none;
  position: sticky;
  top: 0;
  background: #F3F3F3;
  z-index: 1;
  vertical-align: middle !important;
  padding-left: 19px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
